module.exports = __webpack_public_path__ + "static/img/bg_zongheti.a2b9504.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/bg_zongheti.png
// module id = 1dhk
// module chunks = 1